import React from 'react';
import {ShowableProductCard} from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import {observer} from "mobx-react";
import TooltipV1 from "../TooltipV1/TooltipV1";
import {CharacterListValueV1} from "../CharacterListValueV1/CharacterListValueV1";

type VisualProductPropertyGridV1Props = {
    productCard: ShowableProductCard
}

const VisualProductPropertyGridV1 = observer((props: VisualProductPropertyGridV1Props) => {
    const collection = props.productCard.actualFields
        .slice(0, 6)
        .map((v, k) => (
            <div className="visual-product-property-v1" key={k}>
                {v.image !== null &&
                    <div className="visual-product-property-v1__image">
                        <img className="image-v1" src={v.image ?? undefined} alt=""/>
                    </div>
                }
                <div className="visual-product-property-v1__content">
                    <div className="visual-product-property-v1__title">
                        {v.title}
                    </div>
                    <CharacterListValueV1 className="visual-product-property-v1__subtitle" value={v.value}
                                          unit={v.unit}/>
                </div>
            </div>
        ));

    return (
        <div className="visual-product-property-grid-v1">
            {collection}
        </div>
    );

})

export {VisualProductPropertyGridV1};